import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { IParentStyle } from "@dineout-cart-ui/interfaces";
import { isEmpty } from "@swiggy-private/js-utils";

export const ComponentWrapper = styled.div<{
    parentStyle?: IParentStyle;
    backgroundColor?: string;
    borderColor?: string;
    color?: string;
    alignment?: string;
}>(({ theme, parentStyle, backgroundColor, borderColor, color, alignment }) => ({
    background:
        backgroundColor ||
        (parentStyle
            ? `linear-gradient(${parentStyle.angle}deg, ${parentStyle.gradientColor.join(", ")})`
            : theme.colors[theme.colorMode].positive_Sub),
    color: color || theme.colors[theme.colorMode].positive,
    border: borderColor ? `1px solid ${borderColor}` : "none",
    padding: theme.spacing.small,
    borderRadius: theme.cornerRadius.medium,
    display: "flex",
    alignItems: "end",
    justifyContent: "space-between",
    ...(!isEmpty(alignment) && {
        alignItems: "center",
        justifyContent: alignment,
    }),
}));

export const TitleText = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].positive,
    width: "90%",
}));

export const ImageContainer = styled.div(({ theme }) => ({
    marginRight: theme.spacing.xxSmall,
}));
